"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSContextMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../..");
const useFSContextMenu_1 = require("../hooks/useFSContextMenu");
const FSContextMenu = () => {
    const { handleContextMenuClose, contextMenuState } = (0, useFSContextMenu_1.useFSContextMenu)();
    if (!contextMenuState)
        return null;
    return ((0, jsx_runtime_1.jsx)(__1.ContextMenu, Object.assign({ id: "file-system__context-menu", onClose: handleContextMenuClose, event: contextMenuState.event }, { children: contextMenuState.options.map((option, index) => {
            if (option.separator) {
                return (0, jsx_runtime_1.jsx)(__1.ContextMenu.Separator, {}, index);
            }
            return ((0, jsx_runtime_1.jsx)(__1.ContextMenu.Item, Object.assign({ icon: option.icon, onClick: option.onClick, disabled: option.disabled }, { children: option.label }), index));
        }) }), void 0));
};
exports.FSContextMenu = FSContextMenu;
//# sourceMappingURL=FSContextMenu.js.map